import { createContext, Dispatch, SetStateAction, useContext, useMemo } from "react";
import { HomeShow } from "@core/constants";
import { FCX } from "@datassential/platform-ui-lib";
import useQueryState from "@hooks/useQueryState";
import { filterSortContextFactory } from "@hooks/useFilterSortWithContext";
import { HomePeopleRawNormDataItem } from "@api/useHomePeopleRawNormData";

export type PeopleViewContextData = {
    show: HomeShow;
    setShow: Dispatch<SetStateAction<HomeShow>>;
}

const DEFAULTS: PeopleViewContextData = {
    show: HomeShow.Raw,
    setShow: () => null,
}

const PeopleViewContext = createContext<PeopleViewContextData>(DEFAULTS);

export function usePeopleViewContext() {
    return useContext(PeopleViewContext);
}

const PeopleViewContextProvider: FCX = ({
    children,
}) => {
    const [show, setShow] = useQueryState<PeopleViewContextData['show']>('show', DEFAULTS.show);

    const contextValue = useMemo(
        () => ({
            show,
            setShow,
        }),
        [show, setShow]
    )

    return (
        <PeopleViewContext.Provider value={contextValue}>
            {children}
        </PeopleViewContext.Provider>
    );
};

export default PeopleViewContextProvider;

const {
    Context,
    Provider,
} = filterSortContextFactory<HomePeopleRawNormDataItem>();

export const PeopleViewFilterSortContext = Context;
export const PeopleViewFilterSortContextProvider = Provider;